import { render, staticRenderFns } from "./BookingCheckoutComponent.vue?vue&type=template&id=31d867fe&scoped=true"
import script from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"
export * from "./BookingCheckoutComponent.vue?vue&type=script&lang=js"
import style0 from "./BookingCheckoutComponent.vue?vue&type=style&index=0&id=31d867fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d867fe",
  null
  
)

export default component.exports